import api from "./client";

export default {
    getData(user_id) {
        return api.get('/auto-topup/getData/' + user_id);
    },
    setTimer(user_id, data) {
        return api.post('/auto-topup/setTimer/' + user_id, data);
    },
    deleteTimer(user_id, data) {
        return api.post('/auto-topup/deleteTimer/' + user_id, data);
    },
    getCart(user_id) {
        return api.get('/auto-topup/getCart/'+user_id);
    },

}

